export const environment = {
 baseUrl: 'https://api.iskedo.com'
}
